<template>
    <td>
        <button class="btn btn-sm btn-success "
            data-toggle="modal"
            data-target="#editarComponente"
            id="editar-componente"
            type="button"
            title="Editar componente"
        >
            <i class="mr-1 fas fa-edit"></i>
            <span hidden v-text="data.id" class="btnModalGetClass"></span>
        </button>
        <button class="btn btn-sm btn-warning "
            data-toggle="modal"
            data-target="#crearDetalleComponente"
            id="crear-detalle-componente"
            type="button"
            title="Crear detalle componente"
        >
            <i class="mr-1 fas fa-plus"></i>
            <span hidden v-text="data.id" class="btnModalGetClass"></span>
        </button>
    </td>
</template>
<script>
import Axios from 'axios';
export default {
    props: [
        'value',
        'data'
    ],
    data () {
        return {

        }
    },
    methods: {

    }
}
</script>
